import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "../admin/authPage/AdminLogin";
import AdminDashboard from "../admin/pages/AdminDashboard";
import Users from "../admin/pages/users/Users";
import UserDetails from "../admin/pages/users/UserDetails";
import All_post from "../admin/pages/post/All_post";
import Project from "../admin/pages/projects/Project";
import Sepecial_images from "../admin/pages/images_posts/Special_images";
import RequireAuth from "../admin/auth/RequireAuth";
import Error from "../pages/Error";
import Work from "../admin/pages/works/Work";
import ProjectDetails from "../admin/pages/projects/ProjectDetails";
import WorkView from "../admin/pages/works/WorkView";
import Newsletter from "../admin/pages/newsletter/Newsletter";
import Competition from "../admin/pages/competition/Competition";
import ParticipateList from "../admin/pages/competition/ParticipateList";
import CompetitionCreateForm from "../admin/pages/competition/CompetitionCreateForm";
import CompetitionEditForm from "../admin/pages/competition/CompetitionEditForm";
import Claims from "../admin/pages/festival/Claims";
import FestivalPayments from "../admin/pages/festival/FestivalPayments";
import FestivalPaymentDetail from "../admin/pages/festival/FestivalPaymentDetail";
import FestivalAccessControl from "../admin/pages/festival/FestivalAccessControl";
import FinanceSettings from "../admin/pages/settings/FinanceSettings";

// Add this new component at the top of the file
const RequireNoAuth = ({ children }) => {
  const auth = localStorage.getItem("cookies");
  if (auth) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <RequireNoAuth>
            <AdminLogin />
          </RequireNoAuth>
        }
      />

      {/* Protected Routes */}
      <Route element={<RequireAuth />}>
        <Route path="/" element={<AdminDashboard />}>
          <Route index element={<Users />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:userId" element={<UserDetails />} />
          <Route path="/posts" element={<All_post />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/projects/:projectId/:projectTitle" element={<ProjectDetails />} />
          <Route path="/jobs" element={<Work />} />
          <Route path="/jobs/:workId/:workTitle" element={<WorkView />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="**" element={<Error />} />
          {/* <Route path="special-images" element={<Sepecial_images />} /> */}

          <Route path="/competitions" element={<Competition />} />
          <Route path="/competitions/:competition_id/participants" element={<ParticipateList />} />
          <Route path="/competition/create" element={<CompetitionCreateForm />} />
          <Route path="/competition/:competition_id/edit" element={<CompetitionEditForm />} />
          <Route path="/festivals" element={<FestivalAccessControl />} />
          <Route path="/festivals/claims" element={<Claims />} />
          <Route path="/festivals/payments" element={<FestivalPayments />} />
          <Route path="/festivals/payments/:festivalId" element={<FestivalPaymentDetail />} />
          <Route path="/festivals/access-control" element={<FestivalAccessControl />} />
          <Route path="/finance-tax" element={<FinanceSettings />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
